import { render, staticRenderFns } from "./djxxDetail.vue?vue&type=template&id=6610d1e4"
import script from "./djxxDetail.vue?vue&type=script&lang=js"
export * from "./djxxDetail.vue?vue&type=script&lang=js"
import style0 from "./djxxDetail.vue?vue&type=style&index=0&id=6610d1e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports